import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import h4 from '../Images/h4.png'
import Testimonials from './Testimonials';
import ServicesBanner from './ServicesBanner';
import { useNavigate } from 'react-router-dom';
// --- STYLED COMPONENTS ---

const SectionContainer = styled.section`
//   font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 20px;
  color: #333333;
`;

const MainHeader = styled.div`
  // margin-bottom: 40px;
  
  h1 {
    font-size: 2rem;
    font-weight: bold;
    color: #439E6D;
    // margin-bottom: 15px;
  }
`;

// Icon placeholder matching the blue circular icon under Services title
const FeatureIcon = styled.div`
  width: 36px;
  height: 36px;
  background-color: #3b5998; /* Exact blue profile color from image */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: bold;
  font-size: 1.1rem;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 80px;
  row-gap: 40px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    column-gap: 0;
  }
`;

const ServiceCard = styled.div`
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  // min-height: 160px;
`;

const ServiceTitle = styled.h2`
  font-size: 1.2rem;
  font-weight: 600;
  color: #439E6D;
  text-transform: uppercase;
  // margin: 0 0 10px 0;
  letter-spacing: 0.5px;
  line-height: 1.3;
`;

const ServiceDescription = styled.p`
  font-size: 1.1rem;
  color: #555555;
  // margin: 0 0 15px 0;
  line-height: 1.5;
`;

const ActionButton = styled.a`
  align-self: flex-end;
  display: inline-flex;
  align-items: center;
  background-color: #439E6D; /* Sleek corporate slate gray */
  color: #ffffff;
  padding: 8px 16px;
  font-size: 1rem;
  text-decoration: none;
  text-transform: lowercase;
  border-radius: 4px;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;

  &::before {
    content: '>';
    margin-right: 6px;
    font-weight: bold;
    font-size: 0.75rem;
  }

  &:hover {
    background-color: #475569;
  }
`;

// Full Width Feature layout for the 2D High Resolution row
const FullWidthService = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-top: 1px solid #e2e8f0;
  padding-top: 40px;
  // margin-bottom: 60px;
  width: 100%;

  h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #439E6D;
    text-transform: uppercase;
    // margin-bottom: 8px;
  }

  p {
    font-size: 1.1rem;
    color: #555555;
    // margin-bottom: 20px;
  }

  a {
    align-self: flex-end;
    text-transform: lowercase;
  }
`;

// Bottom Hero Banner Grid
const PitchGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 40px;
  align-items: center;
  // margin-top: 60px;
  border-top: 1px solid #e2e8f0;
  padding-top: 10px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const PitchContent = styled.div`
  h2 {
    font-size: 1.8rem;
    font-weight: 600;
    color: #439E6D;
    line-height: 1.3;
    // margin-0: 0 0 20px 0;
  }

  p {
    font-size: 1.1rem;
    color: #4a5568;
    line-height: 1.6;
    // margin-bottom: 30px;
  }
`;

const HireButton = styled.button`
  background-color: #439E6D;
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: #475569;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  background-color: transparent;
 

  img {
    max-width: 100%;
    height: auto;
    object-fit: cover;
     border-radius:20px;
  }
`;

// --- MAIN COMPONENT ---

const ServicesSection = () => {
  const navigate = useNavigate();
  return (
    <SectionContainer>
      
      {/* Header section */}
      <Fade triggerOnce direction="up" duration={800}>
        <MainHeader>
          <h1>Services</h1>
          {/* <FeatureIcon>f</FeatureIcon> */}
        </MainHeader>
      </Fade>

      {/* Services Grid (2 Columns) */}
      <ServicesGrid>
        <Fade triggerOnce direction="up" duration={700} fraction={0.2}>
          {/* Card 1 */}
          <ServiceCard>
            <div>
              <ServiceTitle>ONSHORE<br />SURVEY</ServiceTitle>
              <ServiceDescription>
                We offer onshore survey services for our client on demand at minimal cost effects
              </ServiceDescription>
            </div>
            <ActionButton onClick={()=>navigate('/onshoresurvey')}>more</ActionButton>
          </ServiceCard>

          {/* Card 2 */}
          <ServiceCard>
            <div>
              <ServiceTitle>offshore<br />survey</ServiceTitle>
              <ServiceDescription>
                We offer offshore survey services for clients who demand our services.
              </ServiceDescription>
            </div>
            <ActionButton onClick={()=>navigate('/offshoresurvey')}>more</ActionButton>
          </ServiceCard>

          {/* Card 3 */}
          <ServiceCard>
            <div>
              <ServiceTitle>special<br />survey</ServiceTitle>
              <ServiceDescription>
                We offer specialized survey services for our clients at cost depending on the area,
              </ServiceDescription>
            </div>
            <ActionButton onClick={()=>navigate('/specialsurvey')}>more</ActionButton>
          </ServiceCard>

          {/* Card 4 */}
          <ServiceCard>
            <div>
              <ServiceTitle>engineering<br />SERVICES</ServiceTitle>
              <ServiceDescription>
                We also offer engineering services like steel fabrication and others
              </ServiceDescription>
            </div>
            <ActionButton onClick={()=>navigate('/engineeringservices')}>more</ActionButton>
          </ServiceCard>
        </Fade>
      </ServicesGrid>

      {/* Special Full Width Row Component */}
      <Fade triggerOnce direction="up" duration={800} delay={100} fraction={0.2}>
        <FullWidthService>
          <h2>ANALOGUE GEOPHYSICAL AND 2D HIGH RESOLUTION SEISMIC SURVEY SERVICES</h2>
          <p>he geophysical data provides essential seabed and sub-seabed information</p>
          <ActionButton >learn more</ActionButton>
        </FullWidthService>
      </Fade>

      {/* Bottom Layout Pitch Section */}
      <Fade triggerOnce direction="up" duration={800} delay={150} fraction={0.2}>
        <PitchGrid>
          <PitchContent>
            <h2>We help your time and<br />work for your money.</h2>
            <p>
              We deliver true results, focusing on strategic decisions and practical actions tailored to our clients' unique reality.
            </p>
            <HireButton onClick={()=>navigate('/contactus')} >Hire Us</HireButton>
          </PitchContent>
          
          <ImageContainer>
            {/* Slot setup for the missing picture asset referenced in the design framework layout */}
            <img src={h4} onerror={(e) => e.target.style.display='none'} />
          </ImageContainer>
        </PitchGrid>
      </Fade>

      <Testimonials/>
<ServicesBanner/>
    </SectionContainer>
  );
};

export default ServicesSection;